const setTrackingInfo = async ({ commit }, payload) => {
  commit('SET_TRACKING_INFO', payload)
}
export default {
  setTrackingInfo
}



// WEBPACK FOOTER //
// ./src/store/modules/user/tracking/actions.js